import getXyHeaders from '@/utils/getXyHeaders';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import { IDataSourceTypes } from './types/ICollection';
import { wujiRequest } from './utils/wujiRequest';
import { isOffline } from './utils/wujiWindow';
import { requestWithCache } from './utils/cache';
export async function getRuntimeConfig(options) {
    return await requestWithCache(options, async (options) => {
        const { collectionId, projectId, pageId, envId, simplifyCgiSchema = true, } = options;
        return await wujiRequest({
            url: `${getXyManagePathPrefix({ envId })}/datasource/collection/${collectionId}${addJsonPrefixIfNeeded()}`,
            method: 'get',
            headers: getRuntimeHeaders(simplifyCgiSchema),
            params: {
                projectid: projectId,
                pageid: pageId,
            },
        });
    });
}
export async function getRuntimeConfigList(options) {
    const { collectionIds, projectId, pageId, envId, simplifyCgiSchema = true, simplify = false, } = options;
    return await wujiRequest({
        url: `${getXyManagePathPrefix({ envId })}/datasource/collection${addJsonPrefixIfNeeded()}`,
        headers: getRuntimeHeaders(simplifyCgiSchema),
        params: {
            projectid: projectId,
            pageid: pageId,
            filter: collectionIds?.length ? collectionIds.map(id => `collectionId="${id}"`).join('|') : `type!=${IDataSourceTypes.FRONT_END_HTTP}`,
            include: simplify ? 'collectionId,type,tplType,name' : undefined,
        },
    });
}
function addJsonPrefixIfNeeded() {
    return isOffline() ? '.json' : '';
}
function getRuntimeHeaders(simplifyCgiSchema) {
    if (isOffline())
        return {};
    const headers = getXyHeaders();
    if (simplifyCgiSchema) {
        headers['xy-simplify-cgi-schema'] = 'simplify';
    }
    return headers;
}
